module.exports = __webpack_public_path__ + "img/q5_sp.0d82b298.svg";